import { observable, action, decorate } from 'mobx';

export default class ModalStore {
  show = false;
  data = {};

  openModal = data => {
    this.show = true;
    this.data = data;
  };

  closeModal = () => {
    this.show = false;
  };
}

decorate(ModalStore, {
  show: observable,
  data: observable,
  openModal: action,
  closeModal: action,
});

const modalStore = new ModalStore();

export { modalStore };
